var _ellipse, _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394,
    cy: 140,
    rx: 76,
    ry: 84,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2954_4412",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 30,
    width: 484,
    height: 440
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H491.92V470H8V30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2954_4412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.787 30C328.944 30 281.605 77.2533 281.605 135.023C281.605 155.789 287.927 175.092 298.446 191.429L281.971 247.68C279.747 256.566 288.969 263.961 297.178 259.856L345.123 231.301C357.936 236.869 371.988 240.046 386.787 240.046C444.644 240.046 491.969 192.779 491.969 135.023C491.969 77.2533 444.644 30 386.787 30ZM371.087 72.0092H402.529L399.037 155.732H374.537L371.087 72.0092ZM386.787 171.451C388.969 171.451 390.983 171.802 392.743 172.561C394.531 173.321 396.038 174.361 397.305 175.64C398.544 176.92 399.502 178.424 400.177 180.196C400.853 181.939 401.205 183.851 401.205 185.932C401.191 187.942 400.882 189.784 400.177 191.555C399.502 193.313 398.544 194.831 397.305 196.111C396.038 197.39 394.531 198.43 392.743 199.147C390.983 199.85 388.969 200.216 386.787 200.216C384.576 200.216 382.619 199.879 380.831 199.147C379.085 198.445 377.55 197.39 376.311 196.111C375.072 194.831 374.086 193.313 373.396 191.555C372.692 189.784 372.368 187.928 372.368 185.932C372.368 183.851 372.72 181.939 373.396 180.196C374.086 178.424 375.072 176.92 376.311 175.64C377.55 174.361 379.085 173.321 380.831 172.561C382.619 171.802 384.604 171.451 386.787 171.451ZM165.905 324.064C103.106 324.064 8.13281 361.771 8.13281 418.585V450.092C8.13281 461.691 17.5527 471.097 29.1692 471.097H302.642C314.258 471.097 323.678 461.691 323.678 450.092V418.585C323.678 361.771 228.705 324.064 165.905 324.064Z",
    fill: "#231942"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2954_4412",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 143,
    width: 168,
    height: 162
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 143H256V304.753H88V143Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2954_4412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.477 221.187C244.477 226.33 243.961 231.426 242.977 236.475C241.992 241.524 240.492 246.384 238.57 251.15C236.602 255.868 234.211 260.398 231.352 264.645C228.492 268.939 225.258 272.902 221.648 276.536C218.039 280.122 214.102 283.378 209.836 286.256C205.57 289.087 201.117 291.494 196.383 293.475C191.648 295.41 186.773 296.92 181.758 297.911C176.742 298.902 171.68 299.421 166.523 299.421C161.414 299.421 156.352 298.902 151.336 297.911C146.32 296.92 141.445 295.41 136.711 293.475C131.977 291.494 127.477 289.087 123.258 286.256C118.992 283.378 115.055 280.122 111.445 276.536C107.836 272.902 104.602 268.939 101.742 264.645C98.8828 260.398 96.4922 255.868 94.5234 251.15C92.6016 246.384 91.1016 241.524 90.1172 236.475C89.0859 231.426 88.6172 226.33 88.6172 221.187C88.6172 216.091 89.0859 210.995 90.1172 205.946C91.1016 200.897 92.6016 196.037 94.5234 191.271C96.4922 186.552 98.8828 182.023 101.742 177.729C104.602 173.482 107.836 169.518 111.445 165.885C115.055 162.252 118.992 159.043 123.258 156.165C127.477 153.334 131.977 150.927 136.711 148.945C141.445 146.964 146.32 145.501 151.336 144.51C156.352 143.472 161.414 143 166.523 143C171.68 143 176.742 143.472 181.758 144.51C186.773 145.501 191.648 146.964 196.383 148.945C201.117 150.927 205.57 153.334 209.836 156.165C214.102 159.043 218.039 162.252 221.648 165.885C225.258 169.518 228.492 173.482 231.352 177.729C234.211 182.023 236.602 186.552 238.57 191.271C240.492 196.037 241.992 200.897 242.977 205.946C243.961 210.995 244.477 216.091 244.477 221.187Z",
    fill: "#231942"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaints);
export default __webpack_public_path__ + "static/media/complaints.e16ac9480017da8b9b16b829b360521e.svg";
export { ForwardRef as ReactComponent };